import { Chip } from "@mui/material";
import { useTranslation } from "i18n-fe";
import { isSplitClass } from "../util/classDisplay";

// #1761 — the ONE visible RO/ROO indicator, shared by every surface that
// names a class. An FVD ride-out/split section carries the SAME
// classNumber/className as its base class and is only distinguishable by the
// fractional sngClassID baked into its id (classDisplay#isSplitClass, #883),
// so without this chip the two render as identical "223. <name>" entries and
// a scribe can silently work the wrong one (CDS prod, CNO 462). #883 added
// exactly this chip to the manual-add CNO picker (ClassSearchModal) alone;
// this component lifts that established pattern into every other class
// list/search/header so there is one chip, one string, one detection rule.
// Renders NOTHING for a base (non-split) class — callers drop it in
// unconditionally. Theme tokens only (never MUI `primary`, dark grey and
// invisible against grey.900 in dark mode, #862).
export default function SplitClassChip({
  klass,
  testId = "split-class-chip",
  sx,
}) {
  const { t } = useTranslation("score");
  if (!isSplitClass(klass)) return null;
  return (
    <Chip
      size="small"
      variant="outlined"
      label={t("classes.splitSection")}
      data-testid={testId}
      sx={{ color: "text.primary", borderColor: "text.secondary", ...sx }}
    />
  );
}
